import {
  GET_CHILD_PROGRAMS_RES,
  GET_CHILD_PROGRAMS_REQ,
  GET_CHILD_PROGRAMS_ERR,

  CLEAR_CHILD_PROGRAMS,
} from '../../actions'

const usersInitialState = {
  error: null,
  loading: false,
  loaded: false,
  data: null
}

const childs = ( state = usersInitialState, action) => {
  switch( action.type ){
    case GET_CHILD_PROGRAMS_REQ:
      return {
        ...state,
        loading: true,
      }
    case GET_CHILD_PROGRAMS_RES:
      return {
        ...state,
        data: action.payload,
        loaded: true,
        loading: false
      }
    case GET_CHILD_PROGRAMS_ERR:
      return {
        ...state,
        error: action.payload
      }
    case CLEAR_CHILD_PROGRAMS:
      return {
        state
      }
      default:
          return state
  }
}

export default childs